import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  background: ${({ theme }) => theme.palette.grey[50]};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
`;
